import React, { useCallback } from 'react';
import WarningFlag from '@atlassian/jira-flags/src/common/ui/components/warning-flag'; // ignore-for-ENGHEALTH-17759
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	id: string | number;
	onDismissed: (id: number | string) => void;
};

const ClearCustomFilterFailed = ({ id, onDismissed }: Props) => {
	const { formatMessage } = useIntl();

	const onClick = useCallback(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.location.reload();
	}, []);

	return (
		<WarningFlag
			id={id}
			onDismissed={onDismissed}
			title={formatMessage(messages.endUserTitle)}
			description={formatMessage(messages.endUserDescription)}
			actions={[
				{
					content: formatMessage(messages.endUserActionLink),
					onClick,
				},
			]}
		/>
	);
};

export default ClearCustomFilterFailed;
